import { render } from "./MagicialDetailView.vue?vue&type=template&id=12401399&scoped=true"
import script from "./MagicialDetailView.vue?vue&type=script&lang=js"
export * from "./MagicialDetailView.vue?vue&type=script&lang=js"

import "./MagicialDetailView.vue?vue&type=style&index=0&id=12401399&scoped=true&lang=css"

import exportComponent from "/var/www/xserenedestiny/DuangdeeLiveAdmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12401399"]])

export default __exports__